import { APIClient } from '../../helpers/api_helper';

const api = new APIClient();

export const fetchCategories = (params?: any) => api.get('/api/v1/blogs/admin/category/list', params);
export const addCategory = (data: any) => api.create('/api/v1/blogs/admin/category/add', data);
export const editCategory = (id: string, data: any) => api.create(`/api/v1/blogs/admin/category/edit/${id}`, data);
export const deleteCategory = (id: string) => api.create(`/api/v1/blogs/admin/category/delete/${id}`, {}); 